import isEqual from 'lodash-es/isEqual';
import {
  DependencyList,
  EffectCallback,
  useEffect as useEffectRaw,
  useRef,
} from 'react';

const useDeepCompareMemoize = (value: DependencyList) => {
  const ref = useRef<DependencyList>();

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
};

export const useDeepCompareEffect = (
  callback: EffectCallback,
  dependencies: DependencyList,
) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffectRaw(callback, useDeepCompareMemoize(dependencies));
